import { Link } from "react-router-dom";
import { CalendarDays, Clock, MapPin, ArrowRight } from "lucide-react";
import { HoverZoomImage } from "../motion/Reveal.jsx";

const CATEGORY_IMAGES = {
  "Fitness Event": "/oneiros/perform-speed.jpg",
  "Sports Event": "/oneiros/kat-badminton.jpg",
  Wellness: "/oneiros/european-studio.jpg",
  Family: "/oneiros/fac-kids-arena.jpg",
  Community: "/oneiros/campaign-5l.jpg",
  Tournament: "/oneiros/fac-box-cricket.jpg",
};

export default function EventCard({ event }) {
  return (
    <article
      data-testid={`event-card-${event.id}`}
      className="group flex h-full flex-col overflow-hidden rounded-xl border border-hairline bg-white transition-colors duration-300 hover:border-brand/40"
    >
      <div className="relative">
        <HoverZoomImage src={event.image || CATEGORY_IMAGES[event.category]} alt={event.name} className="aspect-[16/9] w-full" />
        <span className="absolute left-4 top-4 bg-brand px-3 py-1.5 text-[10px] font-bold uppercase tracking-[0.2em] text-white">
          {event.category}
        </span>
      </div>
      <div className="flex flex-1 flex-col gap-3 p-6">
        <h3 className="font-display text-2xl text-navy">{event.name}</h3>
        <ul className="flex flex-col gap-1.5 text-xs text-mute">
          <li className="flex items-center gap-2"><CalendarDays className="h-3.5 w-3.5 text-brand" />{event.date}</li>
          <li className="flex items-center gap-2"><Clock className="h-3.5 w-3.5 text-brand" />{event.time}</li>
          <li className="flex items-center gap-2"><MapPin className="h-3.5 w-3.5 text-brand" />{event.location}</li>
        </ul>
        <p className="text-sm leading-relaxed text-mute">{event.description}</p>
        <Link
          data-testid={`event-cta-${event.id}`}
          to="/contact"
          className="mt-auto inline-flex items-center gap-2 pt-3 text-[11px] font-bold uppercase tracking-[0.2em] text-navy transition-colors group-hover:text-brand"
        >
          Get Updates
          <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      </div>
    </article>
  );
}
